var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"menu-control"},[_c('ejs-menu',{attrs:{"items":_vm.menuItems,"select":_vm.select}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }